const READY_CHANGE_STATE = 'READY_CHANGE_STATE'

const responseChangeCarMapState = (name, value) => {
  return {
    type: READY_CHANGE_STATE,
    name,
    value
  }
}

const changeCarMapState = (name, value) => {
  return (dispatch) => {
    dispatch(responseChangeCarMapState(name, value))
  }
}

export {
  changeCarMapState,
  responseChangeCarMapState,
  READY_CHANGE_STATE,
}
